<template>
	<div
		class="p-6 transition-all duration-500 border shadow-xl sm:p-8 lg:p-10 sm:shadow-2xl bg-white/90 backdrop-blur-md rounded-2xl sm:rounded-3xl border-white/40 hover:shadow-blue-500/10 animate-fade-in-up"
	>
		<div class="mb-6 text-center sm:mb-8">
			<h2 class="mb-3 text-2xl font-bold sm:text-3xl text-slate-900">
				Enter Your KYC Details
			</h2>
			<p class="max-w-2xl mx-auto text-base sm:text-lg text-slate-600">
				Please provide your personal information for verification
			</p>
		</div>
		<form
			@submit.prevent="submitDetails"
			class="grid max-w-2xl grid-cols-1 gap-4 mx-auto sm:gap-5 md:grid-cols-2"
		>
			<div>
				<label
					for="fullName"
					class="block mb-2 text-sm font-medium text-gray-700 sm:text-base"
					>Full Name:</label
				>
				<input
					type="text"
					id="fullName"
					v-model="localKycDetails.fullName"
					required
					class="w-full px-4 py-3 text-base leading-tight text-gray-800 transition-colors duration-200 border-2 border-gray-300 rounded-lg shadow-sm sm:px-4 sm:py-3 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
				/>
			</div>
			<div>
				<label
					for="idNumber"
					class="block mb-2 text-sm font-medium text-gray-700 sm:text-base"
					>ID Number:</label
				>
				<input
					type="text"
					id="idNumber"
					v-model="localKycDetails.idNumber"
					required
					class="w-full px-4 py-3 text-base leading-tight text-gray-800 transition-colors duration-200 border-2 border-gray-300 rounded-lg shadow-sm sm:px-4 sm:py-3 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
				/>
			</div>
			<div>
				<label
					for="kraPin"
					class="block mb-2 text-sm font-medium text-gray-700 sm:text-base"
					>KRA PIN:</label
				>
				<input
					type="text"
					id="kraPin"
					v-model="localKycDetails.kraPin"
					required
					class="w-full px-4 py-3 text-base leading-tight text-gray-800 transition-colors duration-200 border-2 border-gray-300 rounded-lg shadow-sm sm:px-4 sm:py-3 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
				/>
			</div>
			<div>
				<label
					for="phoneNumber"
					class="block mb-2 text-sm font-medium text-gray-700 sm:text-base"
					>Phone Number:</label
				>
				<input
					type="tel"
					id="phoneNumber"
					v-model="localKycDetails.phoneNumber"
					required
					class="w-full px-4 py-3 text-base leading-tight text-gray-800 transition-colors duration-200 border-2 border-gray-300 rounded-lg shadow-sm sm:px-4 sm:py-3 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
				/>
			</div>
			<div class="md:col-span-2">
				<label
					for="email"
					class="block mb-2 text-sm font-medium text-gray-700 sm:text-base"
					>Email:</label
				>
				<input
					type="email"
					id="email"
					v-model="localKycDetails.email"
					required
					class="w-full px-4 py-3 text-base leading-tight text-gray-800 transition-colors duration-200 border-2 border-gray-300 rounded-lg shadow-sm sm:px-4 sm:py-3 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
				/>
			</div>
			<div class="md:col-span-2">
				<label
					for="address"
					class="block mb-2 text-sm font-medium text-gray-700 sm:text-base"
					>Residential Address:</label
				>
				<textarea
					id="address"
					v-model="localKycDetails.address"
					rows="3"
					required
					class="w-full px-4 py-3 text-base leading-tight text-gray-800 transition-colors duration-200 border-2 border-gray-300 rounded-lg shadow-sm sm:px-4 sm:py-3 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
				></textarea>
			</div>

			<div
				class="flex flex-col-reverse justify-between gap-4 mt-6 sm:flex-row md:col-span-2"
			>
				<button
					type="button"
					@click="previous"
					class="w-full px-6 py-3 text-base font-semibold text-blue-600 transition-colors duration-300 border-2 border-blue-600 rounded-full sm:w-auto sm:text-lg hover:bg-blue-50"
				>
					Back
				</button>
				<button
					type="submit"
					class="w-full px-6 py-3 text-base font-semibold text-white transition-colors duration-300 bg-blue-600 rounded-full shadow-lg sm:w-auto sm:text-lg hover:bg-blue-700"
				>
					PReview Summary
				</button>
			</div>
		</form>
	</div>
</template>

<script>
export default {
	name: 'KYCDetailsForm',
	props: ['kycDetails'],
	data() {
		return {
			localKycDetails: {
				fullName: this.kycDetails.fullName || '',
				idNumber: this.kycDetails.idNumber || '',
				kraPin: this.kycDetails.kraPin || '',
				phoneNumber: this.kycDetails.phoneNumber || '',
				email: this.kycDetails.email || '',
				address: this.kycDetails.address || '',
			},
		};
	},
	watch: {
		kycDetails: {
			handler(newVal) {
				this.localKycDetails = { ...newVal };
			},
			deep: true,
			immediate: true,
		},
	},
	methods: {
		submitDetails() {
			if (
				Object.values(this.localKycDetails).every(
					(field) => field !== '' && field !== null,
				)
			) {
				this.$emit('details-submitted', {
					type: 'kyc',
					details: this.localKycDetails,
				});
			} else {
				alert('Please fill in all KYC details.');
			}
		},
		previous() {
			this.$emit('previous-step');
		},
	},
};
</script>

<style scoped>
@keyframes fade-in-up {
	from {
		opacity: 0;
		transform: translateY(30px);
	}
	to {
		opacity: 1;
		transform: translateY(0);
	}
}
.animate-fade-in-up {
	animation: fade-in-up 0.8s ease-out forwards;
}
.backdrop-blur-md {
	backdrop-filter: blur(12px);
	-webkit-backdrop-filter: blur(12px);
}

@media (max-width: 640px) {
	.md\:col-span-2 {
		grid-column: span 1;
	}

	input,
	textarea {
		min-height: 48px;
	}

	button {
		min-height: 48px;
	}
}

@media (max-width: 400px) {
	.p-6 {
		padding: 1.25rem;
	}

	h2 {
		font-size: 1.5rem;
	}

	.text-base {
		font-size: 0.9375rem;
	}
}
</style>
